/**
 * @typedef {Object} OptionDataVizConfig
 * @property {{[key: string]: string | number}} style
 */
/**
 * @typedef {Object} OptionDataVizConfigParams
 * @property {number} width
 * @property {number} height
 */
export class Option {
  /**
   * @constructor
   * @param {Object} args
   * @param {string} args.text
   * @param {string} [args.shortText=""]
   * @param {string} [args.nextId=""]
   * @param {string} [args.letter=""]
   * @param {string} [args.value=""]
   * @param {OptionDataVizConfig | ((args: OptionDataVizConfigParams) => OptionDataVizConfig) | null} [args.dataViz=null] - the type of chart to use in dataviz to represent responses to this question
   */
  constructor({
    text,
    shortText = "",
    nextId = "",
    letter = "",
    value = "",
    dataViz = null,
  }) {
    this._text = text;
    this._shortText = shortText;
    this._nextId = nextId;
    this._letter = letter;
    this._value = value || letter;
    this._dataViz = dataViz;
  }

  get text() {
    return this._text;
  }

  set text(newText) {
    this._text = newText;
  }

  get shortText() {
    if (this._shortText) {
      return this._shortText;
    }
    return this._text;
  }

  set shortText(newShortText) {
    this._shortText = newShortText;
  }

  get nextId() {
    return this._nextId;
  }

  set nextId(newNextId) {
    this._nextId = newNextId;
  }

  get letter() {
    return this._letter;
  }

  /**
   * @param {string} newLetter
   */
  set letter(newLetter) {
    this._letter = newLetter;
  }

  get value() {
    return this._value;
  }

  /**
   * @param {string} newValue
   */
  set value(newValue) {
    this._value = newValue;
  }

  get dataViz() {
    return this._dataViz;
  }

  /**
   * @param {import("./dataVizConfig.js").DataVizConfig} newDataViz
   */
  set dataViz(newDataViz) {
    this._dataViz = newDataViz;
  }
}
